import React, { Component } from 'react'
import { MappingAgeConsumer } from '../../../../context/MappingAgeContext'
import { MappingAgeRangeConsumer } from '../../../../context/MappingAgeRangeContext'
import { MappingBreedConsumer } from '../../../../context/MappingBreedContext'
import { MappingSexConsumer } from '../../../../context/MappingSexContext'
import { MappingSizeConsumer } from '../../../../context/MappingSizeContext'
import { MappingSpecieConsumer } from '../../../../context/MappingSpecieContext'
import { MappingCharacteristicConsumer } from '../../../../context/MappingCharacteristicContext'

type WrapperMappingDataProps = {
  activeTab: string,
  children: any,
}

export default class WrapperMappingData extends Component<WrapperMappingDataProps> {
  render() {
    const { activeTab, children } = this.props

    switch(activeTab) {
      case 'age':
        return (
          <MappingAgeConsumer>
            {({ mappingAge, fetching, requestMappingAgeList, requestMappingAgeFind, requestMappingAgeSave }) => {
              return children({ values: mappingAge, loading: fetching, listMappings: requestMappingAgeList, loadMapping: requestMappingAgeFind, saveMapping: requestMappingAgeSave })
            }}
          </MappingAgeConsumer>
        )
      case 'age-range':
        return (
          <MappingAgeRangeConsumer>
            {({ mappingAgeRange, fetching, requestMappingAgeRangeList, requestMappingAgeRangeFind, requestMappingAgeRangeSave }) => {
              if (mappingAgeRange && mappingAgeRange.specie) {
                mappingAgeRange = {
                  ...mappingAgeRange,
                  specie_uuid: mappingAgeRange.specie.uuid
                }
              }

              return children({ values: mappingAgeRange, loading: fetching, listMappings: requestMappingAgeRangeList, loadMapping: requestMappingAgeRangeFind, saveMapping: requestMappingAgeRangeSave })
            }}
          </MappingAgeRangeConsumer>
        )
      case 'breed':
        return (
          <MappingBreedConsumer>
            {({ mappingBreed, fetching, requestMappingBreedList, requestMappingBreedFind, requestMappingBreedSave }) => {
              // Parser breed relation
              if (mappingBreed && mappingBreed.breed) {
                mappingBreed = {
                  ...mappingBreed,
                  breed_uuid: mappingBreed.breed.uuid
                }
              }
              if (mappingBreed && mappingBreed.specie) {
                mappingBreed = {
                  ...mappingBreed,
                  specie_uuid: mappingBreed.specie.uuid
                }
              }

              return children({ values: mappingBreed, loading: fetching, listMappings: requestMappingBreedList, loadMapping: requestMappingBreedFind, saveMapping: requestMappingBreedSave })
            }}
          </MappingBreedConsumer>
        )
      case 'sex':
        return (
          <MappingSexConsumer>
            {({ mappingSex, fetching, requestMappingSexList, requestMappingSexFind, requestMappingSexSave }) => {
              return children({ values: mappingSex, loading: fetching, listMappings: requestMappingSexList, loadMapping: requestMappingSexFind, saveMapping: requestMappingSexSave })
            }}
          </MappingSexConsumer>
        )
      case 'size':
        return (
          <MappingSizeConsumer>
            {({ mappingSize, fetching, requestMappingSizeList, requestMappingSizeFind, requestMappingSizeSave }) => {
              return children({ values: mappingSize, loading: fetching, listMappings: requestMappingSizeList, loadMapping: requestMappingSizeFind, saveMapping: requestMappingSizeSave })
            }}
          </MappingSizeConsumer>
        )
      case 'specie':
        return (
          <MappingSpecieConsumer>
            {({ mappingSpecie, fetching, requestMappingSpecieList, requestMappingSpecieFind, requestMappingSpecieSave }) => {
              // Parser specie relation
              if (mappingSpecie && mappingSpecie.specie) {
                if (mappingSpecie && mappingSpecie.specie) {
                  mappingSpecie = {
                    ...mappingSpecie,
                    specie_uuid: mappingSpecie.specie.uuid
                  }
                }
              }

              return children({ values: mappingSpecie, loading: fetching, listMappings: requestMappingSpecieList, loadMapping: requestMappingSpecieFind, saveMapping: requestMappingSpecieSave })
            }}
          </MappingSpecieConsumer>
        )
      case 'characteristic':
        return (
          <MappingCharacteristicConsumer>
            {({ mappingCharacteristic, fetching, requestMappingCharacteristicList, requestMappingCharacteristicFind, requestMappingCharacteristicSave }) => {
               // Parser characteristic relation
              if (mappingCharacteristic) {
                if (mappingCharacteristic.characteristic) {
                  mappingCharacteristic = {
                    ...mappingCharacteristic,
                    characteristic_uuid: mappingCharacteristic.characteristic.uuid
                  }
                }
                if (mappingCharacteristic.shelter) {
                  mappingCharacteristic = {
                    ...mappingCharacteristic,
                    shelter_uuid: mappingCharacteristic.shelter.uuid
                  }
                }
              }
              return children({ values: mappingCharacteristic, loading: fetching, listMappings: requestMappingCharacteristicList, loadMapping: requestMappingCharacteristicFind, saveMapping: requestMappingCharacteristicSave })
            }}
          </MappingCharacteristicConsumer>
        )
      default:
        return null
    }
  }
}
